<button
  [ngClass]="buttonCSS"
  nz-button
  nzBlock
  nzType="primary"
  [style.width]="width"
  [style.height]="height"
  [style.background-color]="color"
  [style.color]="color2"
  [disabled]="disabled"
  (click)="onClickButton($event)"
>
  <h3 class="h3"><ng-content></ng-content></h3>
</button>
